import React from 'react';
import { useSelector } from 'react-redux';
import { Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
// slices
import { companySelector } from 'slices/company';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
//styles
import './home.scss'

const BannerPromotional = () => {
  const {home_image, home_url} = useSelector(companySelector);
  const { assignedLibrary } = useAssignedLibrary();

  return (
    <Col md={12} className="container-banner-promotional">
      <Link to={`/${assignedLibrary}/libro/${home_url}`} target="_blank">
        <img src={home_image} alt="Promotional Banner" className="w-100"/>
      </Link>
    </Col>
  );
};

export default BannerPromotional;